import React, { FC } from 'react'

import Modal from 'uiKit/Modal'
import * as S from 'uiKit/UsageMeter/UsageMeter.style'

interface Props {
  open: boolean
  /** Which confirmation to show — the toggle's next state, not its current one. */
  activating: boolean
  onCancel: () => void
  onConfirm: () => void
}

const COPY = {
  activate: {
    title: 'Activate account?',
    text:
      'Activating this account will restore the Care Plan Audit usage limit and start a new monthly cycle from the beginning. The previous monthly cycle will not continue.',
    confirmLabel: 'Activate',
  },
  deactivate: {
    title: 'Deactivate account?',
    text:
      'Deactivating this account will stop the current monthly cycle and reset the Care Plan Audit usage. When the account is reactivated, the Care Plan Audit usage limit will be restored, and a new monthly cycle will begin.',
    confirmLabel: 'Deactivate',
  },
}

/**
 * Guards the QCS table activation toggle — switching either direction resets
 * the renewal cycle, so it is never applied on the click itself. Same shape as
 * RequestSupervisionModeModal: uiKit/Modal plus the shared modal styles.
 */
export const AssistantStatusModal: FC<Props> = ({ open, activating, onCancel, onConfirm }) => {
  const copy = activating ? COPY.activate : COPY.deactivate

  return (
    <Modal open={open} onClose={onCancel} tabIndex="-1">
      <S.ModalBody>
        <S.ModalTitle>{copy.title}</S.ModalTitle>
        <S.ModalText>{copy.text}</S.ModalText>
        <S.ModalActions>
          <S.GhostButton onClick={onCancel}>Cancel</S.GhostButton>
          <S.PrimaryButton onClick={onConfirm}>{copy.confirmLabel}</S.PrimaryButton>
        </S.ModalActions>
      </S.ModalBody>
    </Modal>
  )
}

export default AssistantStatusModal
